(() => {
  function debounce(fn, delay3) {
    let timer = null;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        fn.apply(this, args);
      }, delay3);
    };
  }
  window._debounce = debounce;

  let judgeme_product_reviewsTimSum = 0
  let judgeme_product_reviewsTim = setInterval(() => {
    let judgeme_product_reviews = document.querySelector("#judgeme_product_reviews");
    judgeme_product_reviews?.parentElement.classList.add("judgeme_product_reviews-container");
    if (judgeme_product_reviews || judgeme_product_reviewsTimSum > 100) {
      return clearInterval(judgeme_product_reviewsTim)
    }
  }, 1000);
  // 公共类可继承open属性
  const GlobalHTMLElement = class extends HTMLElement {
    static get observedAttributes() {
      return ["open"];
    }
    constructor() {
      super();
    }
    get open() {
      return this.hasAttribute("open");
    }
    set open(value) {
      if (value) {
        (async () => {
          this.setAttribute("open", "");
        })();
      } else {
        this.removeAttribute("open");
      }
    }

    listenerKeydown() {
      document.addEventListener("keydown", (e) => {
        if (this.open == true && e.code == "Escape") {
          this.open = false;
        }
      });
    }
  };

  // swiper-component 自定义轮播组件
  customElements.define(
    "swiper-component",
    class SwiperComponent extends GlobalHTMLElement {
      custom_pagination = {
        total: 0,
        current: 0,
      };
      swiper_options = {
        slidesPerView: 1,
        spaceBetween: 40,
        loop: false,
        autoplay: false,
        watchOverflow: true,
      };
      constructor() {
        super();
        // 执行一次
        this.lock = true;
        // 自定义切换按钮
        this.custom_prev_btn = this.querySelector(".swiper-pagination-prev");
        this.custom_next_btn = this.querySelector(".swiper-pagination-next");
        this.custom_swiper_tabs = this.querySelectorAll(".swiper-tab-item");
      }
      disconnectedCallback() {
        this.swiper.destroy(true, true);
      }
      connectedCallback() { }
      attributeChangedCallback(name, oldValue, newValue) {
        switch (name) {
          case "open":
            if (this.hasAttribute("open") && this.lock) {
              this.lock = false;
              this.startSwiper();
            }
        }
      }
      startSwiper() {
        this.initPagination();
        this.initSwiper();
        // 自定义切换按钮
        this.initCuPaginationButton();
      }

      initSwiper() {
        Object.keys(this.dataset).forEach((key) => {
          this.swiper_options[key] = JSON.parse(this.dataset[key]);
        });
        this.swiper = new Swiper(this.querySelector(".swiper"), {
          ...this.swiper_options,
        });
        this.swiper["custom_pagination"] = this.custom_pagination;
        this.swiper.on("slideChange", (item) => {
          this.custom_pagination["current"] = item.realIndex + 1;
          this.swiper["custom_pagination"] = this.custom_pagination;
          this.updateCuPaginationButton();
          this.selectTabsItem(item.realIndex);
        });
        if (this.dataset.progress) {
          this.querySelector('.swiper').classList.add("swiper-autoplay")
          this.swiper.on("autoplayTimeLeft", (s, time, progress) => {
            this.style.setProperty(`--pagination-progress`, ((1 - progress) * 100).toFixed(0) + '%')
            // 你可以将 progress 用于进度条或圆环展示
          })
        }

      }
      slideTo(index) {
        this.swiper.slideTo(index);
      }

      initPagination() {
        if (
          this.querySelector(".swiper-button-next") &&
          this.querySelector(".swiper-button-prev")
        ) {
          this.swiper_options.navigation = {
            nextEl: this.querySelector(".swiper-button-next"),
            prevEl: this.querySelector(".swiper-button-prev"),
          };
        }
        if (this.querySelector(".swiper-pagination")) {
          this.swiper_options.pagination = {
            el: this.querySelector(".swiper-pagination"),
            clickable: true,
          };
        }
        if (
          this.querySelector(
            ".swiper-pagination.swiper-pagination-dynamicBullets"
          )
        ) {
          this.swiper_options.pagination = {
            el: this.querySelector(".swiper-pagination"),
            clickable: true,
            dynamicBullets: true,
          };
        }
        if (this.querySelector(".swiper-pagination-custom")) {
          const _this = this;
          this.swiper_options.pagination = {
            el: this.querySelector(".swiper-pagination-custom"),
            clickable: true,
            type: "custom",
            renderCustom: function (swiper, current, total) {
              _this.custom_pagination = {
                current,
                total,
              };
              return null;
            },
          };
        }
      }
      initCuPaginationButton() {
        if (this.custom_next_btn && this.custom_prev_btn) {
          this.updateCuPaginationButton();
          this.custom_prev_btn.onclick = () => {
            this.swiper.slidePrev();
            this.updateCuPaginationButton();
          };
          this.custom_next_btn.onclick = () => {
            this.swiper.slideNext();
            this.updateCuPaginationButton();
          };
        }
        if (this.custom_swiper_tabs.length) {
          this.selectTabsItem(0);
          this.custom_swiper_tabs.forEach((item, index) => {
            item.onclick = () => {
              this.selectTabsItem(index);
            };
          });
        }
      }

      selectTabsItem(index) {
        if (this.custom_swiper_tabs.length) {
          $(this.custom_swiper_tabs)
            .not(this.custom_swiper_tabs[index])
            .removeClass("active");
          this.custom_swiper_tabs[index].classList.add("active");
          this.swiper.slideTo(index);
        }
      }
      updateCuPaginationButton() {
        if (!this.custom_next_btn && !this.custom_prev_btn) return;
        this.custom_prev_btn.disabled = this.swiper.activeIndex == 0;
        this.custom_next_btn.disabled = this.swiper.isEnd;
      }
    }
  );

  /**
   * 唤醒弹窗按钮有两种唤醒方式
   * 1. global-modal-button子元素包含template
   * 2. global-modal-button data-id 不为空
   * 
   * */

  customElements.define("global-modal-button", class GlobalModalButton extends HTMLElement {
    constructor() {
      super();
      this.childHtml = this.querySelector('template')?.innerHTML
    }
    connectedCallback() {
      if (this.childHtml || this.dataset.modalId) {
        this.addEventListener("click", this.openGlobalModalHandle)
      } else {
        return new Error("data-modal-id或子元素template不能为空");
      }

    }
    openGlobalModalHandle() {
      const _this = this
      console.log("this.childHtml", `${this.querySelector('template')?.innerHTML}`)
      if (_this.childHtml) {
        document.dispatchEvent(new CustomEvent('open-global-modal', {
          bubbles: true,
          detail: {
            childHtml: _this.childHtml,
            contentClass: _this.dataset.contentClass
          }
        }))
      } else {
        const modalContainer = document.getElementById(this.dataset.modalId);
        modalContainer.toggleAttribute("open");
        modalContainer.hasAttribute('open') ? document.body.classList.add("overflow-hidden") : document.body.classList.remove("overflow-hidden")
        if (this.dataset.index) {
          modalContainer?.slideTo(this.dataset.index)
        }

      }

    }
    disconnectedCallback() {
      this.removeEventListener("click", this.openGlobalModalHandle)
    }
  }
  );

  customElements.define(
    "global-modal",
    class GlobalModal extends GlobalHTMLElement {
      constructor() {
        super();
        this.childHtml = null
        this.modalContent = this.querySelector(".global-modal-content")
        this.listenerKeydown();
      }
      connectedCallback() {
        this.addEventListener("click", (e) => {
          if (this.open && (e.target == this || e.target == this.querySelector('.global-modal-close'))) {
            this.removeContent()
          }
        });
        document.addEventListener("open-global-modal", (e) => {
          if (this.childHtml != e.detail.childHtml) {
            this.childHtml = e.detail.childHtml
            this.modalContent.innerHTML = e.detail.childHtml;
            e.detail.contentClass && this.modalContent.classList.add(e.detail.contentClass)
          }
          this.open = true;
          document.body.classList.add("overflow-hidden")
        })
      }
      removeContent() {
        this.open = false;
        document.body.classList.remove("overflow-hidden")
      }
    }
  );

  // 加购按钮
  customElements.define(
    "add-cart-button",
    class AddCartButton extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        this.addEventListener("click", () => {
          this.addToCart(this.dataset.variantId);
        });
      }
      addToCart(variantId) {
        const _this = this;
        let formData = {
          items: [
            {
              id: Number(variantId),
              quantity: 1,
            },
          ],
        };
        this.classList.add("button-loading");
        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then((response) => response.json())
          .then((res) => {
            const count = document.querySelector('.jsccount')
            count.innerText = parseInt(count.innerText) + 1
          })
          .catch((error) => {
            console.error("Error:", error);
          })
          .finally(() => {
            _this.classList.remove("button-loading");
          });
      }
    }
  );

  customElements.define(
    "image-lazy-load",
    class ImageLazyLoad extends HTMLElement {
      constructor() {
        super();
        this.image = this.querySelector(".img--lazyload");
        this.initImageLazyLoad();
      }

      initImageLazyLoad() {
        if ("IntersectionObserver" in window) {
          const lazyImageObserver = new IntersectionObserver(function (
            entries,
            observer
          ) {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                let lazyImage = entry.target;
                lazyImage.src = lazyImage.dataset.src;
                lazyImage.classList.add("lazyloaded");
                observer.unobserve(entry.target);
              }
            });
          });
          lazyImageObserver.observe(this.image);
        } else {
          let active = false;
          const _this = this;
          let lazyLoad = () => {
            if (active === false) {
              active = true;
              setTimeout(() => {
                const lazyImage = _this.image;
                if (
                  lazyImage.getBoundingClientRect().top <= window.innerHeight &&
                  lazyImage.getBoundingClientRect().bottom >= 0 &&
                  getComputedStyle(lazyImage).display !== "none"
                ) {
                  lazyImage.src = lazyImage.dataset.src;
                  // lazyImage.classList.remove("lazy");
                  lazyImage.classList.add("lazyloaded");
                }
                active = false;
              }, 200);
            }
          };
          document.addEventListener("scroll", lazyLoad);
          window.addEventListener("resize", lazyLoad);
          window.addEventListener("orientationchange", lazyLoad);
        }
      }
    }
  );

  class NavigationSticky extends HTMLElement {
    constructor() {
      super();
      this.stickyContainer = document.getElementById(
        `${this.dataset.stickyId}`
      );
      if (!this.stickyContainer) return;
      this.headerHeight =
        document
          .querySelector(".shopify-section--header")
          ?.getBoundingClientRect().height ?? 0;
      this.announcementBarHeight =
        document
          .querySelector(".shopify-section--announcement-bar")
          ?.getBoundingClientRect().height ?? 0;
      this.listenerScroll();
      this.listenerItemHandle()
    }

    listenerItemHandle() {
      const links = Array.from(this.querySelectorAll(".product-navigation-link"))
      links.forEach((item) => {
        item.onclick = () => {
          item.classList.add("active")
          links.filter(t => t != item).forEach(t => t.classList.remove('active'))
        }
      })
    }
    listenerScroll() {
      window.addEventListener("scroll", () => {
        if (this.getScrollTop() > this.getBoundingClientRect().top) {
          this.updateElementTopValue();
        }
      });
    }
    updateElementTopValue() {
      if (this.isScrollDown()) {
        this.stickyContainer.style.top = `-${this.headerHeight}px`;
      } else {
        this.stickyContainer.style.top = `${this.headerHeight + this.announcementBarHeight
          }px`;
      }
    }
    isScrollDown() {
      const scrollY = this.getScrollTop();
      let delta = scrollY - this.curScrollY;
      this.curScrollY = scrollY;
      return delta > 0;
    }
    getScrollTop() {
      return (
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.scrollY ||
        0
      );
    }
  }
  customElements.define("navigation-sticky", NavigationSticky);

  customElements.define(
    "global-tabs",
    class SectionPartnersContent extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.tabs = this.querySelectorAll(".global-tab");
        this.currentItem = this.tabs[0]
        this.updateSlider();

        const swiperContainer = document.querySelector(
          "#" + this.dataset.swiperId
        )?.swiper;

        swiperContainer.on("slideChange", (e) => {
          this.currentItem = this.tabs[e.activeIndex]
          this.updateSlider();
        });
        this.tabs.forEach((item, index) => {
          item.addEventListener("click", () => {
            if (this.currentItem == item) return
            swiperContainer.slideTo(index);
            this.currentItem = item
            this.updateSlider();
          });
        });

        document.addEventListener("windowResize", () => {
          this.updateSlider()
        })
      }
      updateSlider() {
        this.currentItem.classList.add("active");
        $(this.tabs).not(this.currentItem).removeClass("active");
        const { offsetLeft, offsetWidth } = this.currentItem;
        $(this).css({
          ["--global-tab-left"]: offsetLeft + "px",
          ["--global-tab-width"]: offsetWidth + "px",
        });
      }
    }
  );
  customElements.define("section-product-navs", class SectionProductNavs extends HTMLElement {
    constructor() {
      super()
      this.header = document.querySelector(".header__container")
      this.navContainer = document.querySelector(".section-product-navs--sticky")
      this.swiper = this.querySelector("swiper-component")?.swiper ?? {}
      this.init()
      this.listenerScroll()
    }
    init() {
      this.targetElements = Array.from(document.querySelectorAll(".section-anchor-target"))
      this.slides = Array.from(this.querySelectorAll(".slide-navs--item"))
      this.slides.forEach((t, index) => {
        t.onclick = () => {
          this.swiper.slideTo(index)
          this.toTarget(index)
        }
      })
    }
    listenerScroll() {
      window.addEventListener(
        "scroll",
        debounce(() => {
          if (this.header) {
            this.updateElementTopValue()
          }
        }, 1)

      );
    }
    toTarget(index) {
      const anchor = this.targetElements?.[index]
      anchor?.scrollIntoView({ block: 'start', behavior: 'smooth' })
    }
    updateElementTopValue() {
      if (this.isScrollDown()) {
        this.navContainer.style.top = 0
        this.header.style.top = `-${this.header.clientHeight}px`
      } else {
        this.header.style.top = 0
        this.navContainer.style.top = `${this.header.clientHeight - 1}px`
      }
    }
    isScrollDown() {
      const scrollY = this.getScrollTop();
      let delta = scrollY - this.curScrollY;
      this.curScrollY = scrollY
      return delta > 0;
    }
    getScrollTop() {
      return (
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.scrollY ||
        0
      );
    }

  })

  customElements.define("slide-navs", class SlideNavs extends HTMLElement {
    constructor() {
      super()
      this.swiper = this.querySelector("swiper-component")?.swiper ?? {}
      this.header = document.querySelector(".header__container")
      this.navContainer = document.querySelector(".slide-navs__container")
      this.init()
      this.listenerScroll()
    }
    init() {
      this.slides = Array.from(this.querySelectorAll(".slide-navs--item"))
      this.targetElements = Array.from(document.querySelectorAll(".section-anchor-target"))
      this.slides.forEach((t, index) => {
        t.onclick = () => {
          // this.selectActive(index)
          this.toTarget(index)
        }
      })
      this.selectActive(0)
    }
    selectActive(index) {
      const currentItem = this.slides[index]
      this.slides.filter(p => p != currentItem).forEach(p => p.classList.remove('active'))
      currentItem.classList.add("active")
    }
    listenerScroll() {
      window.addEventListener(
        "scroll",
        debounce(() => {
          this.targetElements.forEach((t, index) => {
            if (t.getBoundingClientRect().top < 500) {
              this.selectActive(index)
              this.swiper?.slideTo(index)
            }
          })
          if (this.header) {
            this.updateElementTopValue()
          }
        }, 1)

      );
    }
    updateElementTopValue() {
      if (this.isScrollDown()) {
        this.navContainer.style.top = 0
        this.header.style.top = `-${this.header.clientHeight}px`
      } else {
        this.header.style.top = 0
        this.navContainer.style.top = `${this.header.clientHeight - 1}px`
      }
    }
    isScrollDown() {
      const scrollY = this.getScrollTop();
      let delta = scrollY - this.curScrollY;
      this.curScrollY = scrollY
      return delta > 0;
    }
    getScrollTop() {
      return (
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.scrollY ||
        0
      );
    }
    toTarget(index) {
      const anchor = this.targetElements?.[index]
      anchor?.scrollIntoView({ block: 'start', behavior: 'smooth' })
    }
  })

  class VideoLazyLoad extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.video = this.querySelector(".video--lazyLoad");
      // 人机是否有交互
      this.interactState = false;
      this.autoplayMap = [];
      // this.listenerIntersectionObserver()
      this.listenerInteract();
      this.listenerALick();
    }

    listenerIntersectionObserver() {
      const _this = this;
      this.videoObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach((entry) => {
          let video = entry.target;
          if (entry.isIntersecting) {
            video.src = video.dataset.src;
            if (video.dataset.poster) {
              video.poster = video.dataset.poster;
            }
            if (video.dataset.autoplay) {
              // 有交互性则自动播放
              video.play();
              // _this.interactState ? video.play() : _this.autoplayMap.push(video)
            }

            // observer.unobserve(entry.target);
          } else {
            // 不在可视区暂停播放
            video.src && video.pause();
          }
        });
      });

      this.videoObserver.observe(this.video);
      //   this.videos.forEach((item) => {
      //     this.videoObserver.observe(item);
      //   });
    }
    listenerInteract() {
      const startEvent = () => {
        this.listenerIntersectionObserver();
        // this.interactState = true
        // this.autoplayMap.forEach(video => video.play())
      };
      document.addEventListener("mousemove", startEvent, { once: true });
      document.addEventListener("touchstart", startEvent, { once: true });
    }

    listenerALick() {
      document.addEventListener("click", (event) => {
        if (
          event.target.tagName === "A" &&
          event.target.getAttribute("href") &&
          this.video
        ) {
          //   this.videos.forEach((video) => video.pause());
          this.video.pause();
        }
      });
    }
  }
  customElements.define("video-lazy-load", VideoLazyLoad);

  customElements.define("youtube-lazy-load", class YoutubeLazyLoad extends HTMLElement {
    constructor() {
      super()
      this.youtubeSection = this.querySelector('.youtube-lazy--section')
      this.createScript()
      const _this = this
      document.addEventListener("youTubeReady", () => {
        console.log("YouTube API 已加载");
        _this.scrollView()
      })
    }
    scrollView() {
      const _this = this
      const observer = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (!entry.target.playVideo) {
              _this.init(entry.target)
            }
          } else {
            entry.target.pauseVideo?.()
          }
        });
      });
      observer.observe(this.youtubeSection)
    }
    init(section) {
      if (section.playVideo) return;
      if (window.YT) {
        const target = section.querySelector('.youtube-lazy--load')
        const playe = new window.YT.Player(target, {
          ...target.dataset
        });
        section.playVideo = function () {
          playe.playVideo?.()
        }
        section.pauseVideo = function () {
          playe.pauseVideo?.()
        }
      }
    }
    disconnectedCallback() {
      // this.modalContainer.removeEventListener("click")
    }

    createScript() {
      const scriptTags = Array.from(document.getElementsByTagName('script'));
      const youtubeScript = scriptTags.find(t => t.src == "https://www.youtube.com/player_api")
      if (!youtubeScript) {
        let tag = document.createElement('script');
        tag.src = "https://www.youtube.com/player_api";
        scriptTags[0].parentNode.insertBefore(tag, scriptTags[0]);
        console.log('新加载')
        window.onYouTubeIframeAPIReady = function () {
          document.dispatchEvent(new CustomEvent("youTubeReady", {}))
        }
      } else {
        this.scrollView(this)
      }
    }
  })

  customElements.define("slide-toggle", class SlideToggle extends HTMLElement {
    constructor() {
      super();
      this.init()
    }
    init() {
      this.footerLinks = this.querySelectorAll('.slide-toggle--item');
      this.addEventListeners();
    }
    addEventListeners() {
      this.footerLinks.forEach((link) => {
        link.addEventListener('click', () => {
          link.classList.toggle('active');
          $(link.nextElementSibling).slideToggle(300);
        });
      });
    }
  });

  class CountDown extends HTMLElement {
    constructor() {
      super();
      this.initDayjs();
      this.init();
    }

    // 初始化 dayjs 插件
    initDayjs() {
      dayjs.extend(window.dayjs_plugin_utc);
      dayjs.extend(window.dayjs_plugin_timezone);
    }

    init() {
      const {
        numberClass,
        downEndTime,
        timeZones = "America/Los_Angeles",
      } = this.dataset;

      if (!downEndTime) {
        console.error("⛔ CountDown 缺少 downEndTime！");
        return;
      }
      this.timeDoms = this.querySelectorAll(`.${numberClass}`);
      this.timeZones = timeZones;
      this.downEndTime = downEndTime;

      this.setTargetTime();
      this.start();
    }

    // 设置目标结束时间戳
    setTargetTime() {
      this.setTime = this.getTargetTime(this.downEndTime).valueOf();
      console.log("⏳ CountDown 目标时间:", this.setTime, "当前时区:", this.timeZones);
    }

    // 启动倒计时
    start() {
      this.stop();
      this.intervalTime = setInterval(this.updateCountdown.bind(this), 1000);
      this.updateCountdown(); // 立即执行一次，避免初始延迟
    }

    // 停止倒计时
    stop() {
      if (this.intervalTime) {
        clearInterval(this.intervalTime);
        this.intervalTime = null;
      }
    }

    // 当前时区时间
    getCurrentTime() {
      return dayjs().tz(this.timeZones);
    }

    // 获取指定时区时间（带容错）
    getTargetTime(time) {
      if (!time) return this.getCurrentTime();

      let parsed = dayjs.tz(time, this.timeZones);

      // 容错：支持 YYYY/MM/DD 格式
      if (!parsed.isValid()) {
        parsed = dayjs.tz(time.replace(/-/g, "/"), this.timeZones);
      }

      if (!parsed.isValid()) {
        console.error("⛔ Invalid time:", time);
        return this.getCurrentTime();
      }

      return parsed;
    }

    // 倒计时逻辑
    updateCountdown() {
      const now = this.getCurrentTime().valueOf();
      let remainingSeconds = Math.floor((this.setTime - now) / 1000);
      // 倒计时结束
      if (remainingSeconds <= 0) {
        this.stop();
        if (document.getElementById(`coupon-${this.dataset.removeId}`)) {
          document.getElementById(`coupon-${this.dataset.removeId}`).remove();
        }
        return;
      }

      // 转换为 d/h/m/s
      const d = Math.floor(remainingSeconds / 86400);
      const h = Math.floor((remainingSeconds / 3600) % 24);
      const m = Math.floor((remainingSeconds / 60) % 60);
      const s = Math.floor(remainingSeconds % 60);

      // 渲染到页面
      if (this.timeDoms?.length) {
        const values = [d, h, m, s].map(v => String(v).padStart(2, "0"));
        this.timeDoms.forEach((dom, i) => (dom.innerText = values[i]));
      }
    }
  }
  customElements.define("count-down", CountDown);

  customElements.define("header-navigation", class headerNavigation extends HTMLElement {
    constructor() {
      super();
      this.init();
      if (this.dataset.isIndex) {
        this.listenerIntersectionObserver();
      }
    }
    init() {
      this.menuItems = Array.from(this.querySelectorAll(".header-menu-item"));
      let firstHover = true;

      this.menuItems.forEach(item => {
        const dropdown = item.querySelector(".header-menu-dropdown");
        const leftNavs = Array.from(item.querySelectorAll(".header-menu-item-left-nav"));
        const contents = Array.from(item.querySelectorAll(".header-menu-item-content"));

        if (!leftNavs.length) return;

        // 左侧导航切换事件（只绑定一次）
        leftNavs.forEach((leftNav, index) => {
          leftNav.addEventListener("mouseenter", () => {
            leftNavs.forEach((nav, i) => {
              nav.classList.toggle("active", i === index);
              contents[i].classList.toggle("active", i === index);
            });
          });
        });

        item.addEventListener("mouseenter", () => {
          $(dropdown).stop(true, true).slideDown(firstHover ? 200 : 0, "linear");
          firstHover = false;

          if (!leftNavs.some(nav => nav.classList.contains("active"))) {
            leftNavs[0].classList.add("active");
            contents[0].classList.add("active");
          }
        });

        item.addEventListener("mouseleave", () => {
          $(dropdown).stop(true, true).slideUp(0);
        });
      });

      this.querySelector('.header-menu-desktop').addEventListener("mouseleave", () => {
        firstHover = true; // 重新允许动画
      });
    }


    listenerIntersectionObserver() {
      window.addEventListener("scroll", () => {
        if (window.scrollY > 100) {
          this.querySelector('.header-v2--container').classList.remove('is--index')
        } else {
          this.querySelector('.header-v2--container').classList.add('is--index')
        }
      });
    }
  });

  customElements.define("header-navigation-mobile", class headerNavigationMobile extends HTMLElement {
    constructor() {
      super();
      this.init();
      this.initControls()
    }
    init() {
      const menuMobiles = Array.from(this.querySelectorAll(".menu-mobile"));
      const menuItemTriggers = Array.from(this.querySelectorAll(".menu-mobile-trigger"));
      const menuSubMobile = Array.from(this.querySelectorAll(".menu-sub-mobile"));
      const menuMobileContainer = this.querySelector(".menu-mobile-container");
      const menuMobileContainerClose = this.querySelectorAll(".menu-mobile-container-close");
      this.menuMobileContainer = menuMobileContainer
      const menuSubMobileItems = Array.from(this.querySelectorAll(".menu-link-mobile-item"));
      this.menuMobiles = menuMobiles
      this.selectItem(menuSubMobile)
      this.selectItem(menuSubMobileItems)

      menuMobiles.forEach((item, index) => {
        item.onclick = () => {
          menuMobileContainer.classList.add('active')
          menuItemTriggers[index].classList.add('active')
          menuItemTriggers.filter((_, i) => i != index).forEach(t => t.classList.remove('active'))
        }
      })
      menuMobileContainerClose.forEach(t => {
        t.onclick = () => {
          menuMobileContainer.classList.remove('active')
        }
      })
    }
    selectItem(list) {
      list.forEach((item) => {
        item.onclick = () => {
          $(item).toggleClass('active').next().slideToggle(300)
        }
      })
    }

    initControls() {
      document.querySelector("#header-menu-mobile-open")?.addEventListener("click", () => {
        this.setAttribute("open", '')
      })
      this.querySelectorAll(".header-navigation-mobile-close").forEach((item) => {
        item.addEventListener("click", () => {
          this.removeAttribute("open")
          this.menuMobileContainer.classList.remove("active")
        })
      })
    }
  })

  customElements.define("product-quantity", class SectionProductHeader extends GlobalHTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      const minusButton = this.querySelector("[data-product-quantity-minus]")
      const plusButton = this.querySelector("[data-product-quantity-plus]")
      const input = this.querySelector("input[name='quantity']")
      minusButton.addEventListener("click", () => {
        let value = parseInt(input.value) || 1
        if (value > 1) {
          input.value = value - 1
        }
      })
      plusButton.addEventListener("click", () => {
        let value = parseInt(input.value) || 0
        if (value < 9999) {
          input.value = value + 1
        }
      })
    }
  })

  customElements.define("section-product-header", class SectionProductHeader extends HTMLElement {
    constructor() {
      super()
      this.initVariants()
      this.cacheElements()
      this.linearVariantChange()
      this.linearProductForm()
      this.linearSwitch()
    }
    cacheElements() {
      this.cache = {
        price: this.querySelectorAll("[data-variant-price]"),
        crossedPrice: this.querySelector("[data-variant-crossed-price]"),
        discountPrice: this.querySelector("[data-variant-discount-price]"),
        sku: this.querySelector("[data-variant-sku]"),
        masterSelect: this.querySelector("input[name='id']"),
        quantity: this.querySelector("input[name='quantity']"),
        form: this.querySelector("form"),
        addCartButtons: this.querySelectorAll("[data-product-add-to-cart]"),
        imageSwiper: this.querySelector("#swiper-thumbs--image")?.swiper,
        switchSwiper: this.querySelector("#swiper-thumbs--switch")

      }
    }
    linearProductForm() {
      this.cache.form.addEventListener('submit', (event) => {
        event.preventDefault();
        const data = {
          items: []
        };
        const recommendedProductElements = Array.from(this.querySelectorAll("[data-recommended-product]")).map(el => {
          const input = el.querySelector("input:checked");
          const number = el.querySelector("input[name='quantity']").value;
          return input ? { id: input.value, quantity: number } : null;
        }).filter(Boolean);
        const formData = new FormData(this.cache.form);
        data.items.push(Object.fromEntries(formData.entries()))
        recommendedProductElements.forEach(item => {
          data.items.push({
            id: item.id,
            quantity: item.quantity,
            utf8: '✓',
            form_type: 'product'
          });
        });

        this.fetchAddToCart(data);
      });
    }

    updateAddToCartButtonLoading(isLoading) {
      if (isLoading) {
        this.cache.addCartButtons.forEach(button => button.classList.add("button-loading"));
      } else {
        this.cache.addCartButtons.forEach(button => button.classList.remove("button-loading"));
      }
    }
    updateAddToCartButtonState(state) {
      const buttonData = this.dataset.buttonData ? JSON.parse(this.dataset.buttonData) : {};
      if (state) {
        this.cache.addCartButtons.forEach(button => {
          button.innerText = buttonData.buttonSoldOut || button.innerText;
          button.setAttribute("disabled", "disabled")
        });
      } else {
        this.cache.addCartButtons.forEach(button => {
          button.innerText = buttonData.buttonDefault || button.innerText;
          button.removeAttribute("disabled");
        });
      }
    }
    updateCartCount(index) {
      const tcount = document.querySelector(".tcount.jsccount")
      if (tcount) {
        tcount.innerText = parseInt(tcount.innerText ?? 0) + index
      }
    }
    fetchAddToCart(data) {
      this.updateAddToCartButtonLoading(true)
      this.updateAddToCartButtonState(true);
      fetch(`${Shopify.routes.root}cart/add.js`, {
        body: JSON.stringify(data),
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          // Needed for Shopify to check inventory
          "Content-Type": "application/json"
        }
      }).then(response => {
        if (response.ok) {
          this.updateCartCount(data.items.length)
        } else {
          console.error('Error adding to cart:', response);
          alert('Error adding to cart. Please try again.');
        }
      }).catch(error => {
        alert('Error adding to cart. Please try again.', JSON.stringify(error));
      }).finally(() => {
        this.updateAddToCartButtonState(false);
        this.updateAddToCartButtonLoading(false)
        // Reset the form or provide user feedback
      });
    }
    linearVariantChange() {
      this.querySelectorAll("[data-variant-input]").forEach(el => {
        el.addEventListener('change', this.onSelectChange.bind(this));
      });
    }
    onSelectChange(el) {
      const variant = this.getVariantOption(el.target.dataset.variantId)
      if (variant) {
        this.updateAddToCartButtonState(false);
        this.updateSwiperImages(variant)
        this.updateMasterSelect(variant)
        this.updatePrice(variant)
        this.updateUnitPrice(variant)
        this.updateSKU(variant)
        this.updateUrlvariantId(variant)
      } else {
        this.updateAddToCartButtonState(true);
      }

    }
    updateUrlvariantId(variant) {
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      // 不刷新页面更新 URL
      history.replaceState(null, '', url);
    }
    updateSKU(variant) {
      this.cache.sku.innerText = variant.sku
    }
    updateUnitPrice() {

    }
    updatePrice(variant) {
      let discount_amount = variant.compare_at_price - variant.price
      this.cache.price.forEach(el => el.innerHTML = geckoShopify.formatMoney(variant.price))
      if (discount_amount <= 0) {
        this.cache.crossedPrice.classList.add("tw-hidden")
        this.cache.discountPrice.classList.add("tw-hidden")
      } else {
        this.cache.discountPrice.classList.remove("tw-hidden")
        this.cache.crossedPrice.classList.remove("tw-hidden")
        this.cache.discountPrice.querySelector('.discount-amount').innerHTML = geckoShopify.formatMoney(discount_amount)
        this.cache.crossedPrice.innerHTML = geckoShopify.formatMoney(variant.compare_at_price)
      }
    }
    updateSwiperImages(variant) {
      if (!variant.featured_media) return
      const index = this.cache.imageSwiper.slides.find(t => Number(t.dataset.mediaId) == variant.featured_media.id)?.dataset.index
      this.cache.imageSwiper.slideTo(index)

    }
    updateMasterSelect(variant) {
      this.cache.masterSelect.value = variant.id
      console.log(this.cache.masterSelect.value)
    }
    linearSwitch() {
      const items = Array.from(this.querySelectorAll(".swiper-thumbs--switch-btn"))
      items.forEach((item, index) => {
        item.onclick = () => {
          item.classList.add("active")
          items.filter(t => t != item).forEach(t => t.classList.remove("active"))
          this.cache.switchSwiper.slideTo(index)
        }
      })
    }
    getVariantOption(variantId) {
      return this.variantJson.find(t => t.id == variantId)
    }
    initVariants() {
      this.variantJson = JSON.parse(this.querySelector("[data-variant-json]").innerHTML ?? "[]")
      this.currentVariantJson = JSON.parse(this.querySelector("[current-variant-json]") ?? "{}")
    }
  })

  customElements.define("add-to-cart-fixed", class AddToCartFixed extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      const _this = this
      const observerEvent = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            _this.removeAttribute("open")
          } else {
            _this.setAttribute("open", '')
          }
        });
      });
      observerEvent.observe(document.querySelector('.product-add-to-cart'))

    }
  })

  customElements.define("product-coupon", class ProductCoupon extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      this.copyBtn = this.querySelector("[data-copy-btn]");
      this.copyBtnText = this.copyBtn.innerText
      this.copyBtn.addEventListener("click", () => {
        this.copyText(this.dataset.code);
      });
    }

    copyText(text) {
      if (!navigator.clipboard) {
        // 如果不支持 clipboard API，则使用后备方案
        this.fallbackCopyText(text);
        return;
      }

      navigator.clipboard.writeText(text)
        .then(() => {
          this.copyBtn.innerText = "Copy successful";
          this.setBtnText();
        })
        .catch(err => {
          console.error('复制失败:', err);
        });
    }
    setBtnText() {
      clearTimeout(this.time)
      this.time = setTimeout(() => {
        this.copyBtn.innerText = this.copyBtnText;
      }, 2000);

    }
    fallbackCopyText(text) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      this.copyBtn.innerText = "Copy successful";
      this.setBtnText();
    }
  })

  customElements.define("section-home-full", class SectionHomeFull extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      const videoContainer = this.querySelector(".section-home-full-video")
      const video = this.querySelector(".section-home-full-video video")
      if (!video) return
      const play_btn = this.querySelector(".section-home-full-play")
      const pause_btn = this.querySelector(".section-home-full-pause")
      play_btn.onclick = () => {
        video.play()
        play_btn.style.display = "none"
        pause_btn.style.display = "block"
        videoContainer.classList.add("playing")
      }
      pause_btn.onclick = () => {
        video.pause()
        play_btn.style.display = "block"
        pause_btn.style.display = "none"
        videoContainer.classList.remove("playing")
      }

    }
  })

  customElements.define("section-popup", class SectionPopup extends GlobalHTMLElement {
    constructor() {
      super()
      this.show_delay = Number(this.dataset.showDelay ?? 5000) // 首次进入页面五秒后弹出
      this.cool_down_days = Number(this.dataset.coolDownDays ?? 3) // 关闭后 3 天内不再显示
      this.campaign_version = 'popup_' + this.dataset.campaignVersion
      this.initPopupEvent()
      this.initPopup()
      this.listenerClose()
    }
    initPopup() {
      // 提交成功后的直接弹窗
      if (this.checkSuccess()) {
        const popup_items = this.querySelectorAll(".section-popup--item")
        popup_items[0].classList.add("active")
        popup_items[1].classList.remove("active")
        this.showPopup()
        return
      }
      // 检测版本
      if (this.checkCampaignVersion() || !this.isInCoolDown()) {
        this.initOnePopup()
      }
    }

    checkSuccess() {
      const form_id = this.dataset.formId
      const { hash, search } = window.location
      return search.includes("customer_posted=true") && hash.includes(form_id)
    }

    initOnePopup() {
      switch (this.dataset.popupType) {
        case "delay":
          // 用户第一次访问 -> 5秒后弹出
          this.delayPopup()
          break;
        default:
          // 第一次访问滑动30%后弹出
          this.scrollPopup()
          break;
      }
    }
    delayPopup() {
      clearTimeout(this.time)
      this.time = setTimeout(() => {
        this.showPopup()
        this.setAttribute("show", "")
      }, this.show_delay);
    }
    initPopupEvent() {
      this.close_btn = this.querySelector(".section-popup-close")
      this.close_btn.onclick = () => {
        this.removePopup()
      }

    }
    getStatus() {
      return JSON.parse(localStorage.getItem('popup_newsletter_status') || '{}');
    }
    setStatus(data) {
      data.campaign_version = this.campaign_version;
      localStorage.setItem('popup_newsletter_status', JSON.stringify(data));
    }
    removePopup() {
      this.setStatus({ closedTime: Date.now(), floatVisible: false });
      this.remove()
    }
    hidePopup() {
      const status = this.getStatus();
      // this.open = false
      // status.floatVisible = true; // 显示浮动按钮
      this.setStatus({ closedTime: Date.now(), floatVisible: false });
      // this.setStatus(status);
    }
    showPopup() {
      this.open = true
    }
    isInCoolDown() {
      const status = this.getStatus();
      if (!status.closedTime) return false;
      return (Date.now() - status.closedTime) < this.cool_down_days * 24 * 60 * 60 * 1000;
    }
    checkCampaignVersion() {
      const status = this.getStatus();
      if (status.campaign_version !== this.campaign_version) {
        // 版本不同 -> 重置状态
        localStorage.removeItem('popup_newsletter_status');
        return true
      }
      return false
    }
    listenerClose() {
      const popup_container = this.querySelector(".section-popup-container")
      popup_container.addEventListener("click", (e) => {
        if (this.open && (e.target == popup_container || e.target == this.querySelector('.section-popup-close'))) {
          this.close_btn.click()
        }
      });
    }
    scrollPopup() {
      this.scrollHandler = () => {
        if (this.scroll_triggered || this.open) return
        const scrollTop = window.scrollY || document.documentElement.scrollTop
        const docHeight = document.documentElement.scrollHeight - window.innerHeight
        const scrollPercent = scrollTop / docHeight
        if (scrollPercent >= 0.3) { // 滚动超过30%
          this.scroll_triggered = true
          clearTimeout(this.time) // 清除5秒延时触发
          this.showPopup()
          this.setAttribute("show", "")
          window.removeEventListener("scroll", this.scrollHandler)
        }
      }
      window.addEventListener("scroll", this.scrollHandler)
    }
  })

  customElements.define("section-host-tabs", class SectionHostTabs extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      const swipers = this.querySelectorAll("swiper-component")
      const tabs = Array.from(this.querySelectorAll(".section-host-tab"))
      tabs.forEach((item, index) => {
        item.onclick = () => {
          item.classList.add('active')
          tabs.filter(t => t != item).forEach(t => t.classList.remove('active'))
          swipers.forEach(swiper => {
            swiper.slideTo(index)
          })
        }
      })
    }
  })

  customElements.define("country-language", class CountryLanguage extends GlobalHTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      const close_btn = this.querySelector(".country-language-close")
      close_btn.onclick = () => {
        this.open = false
      }
      const open_btn = document.querySelector(".country-language-open")
      if (open_btn) {
        open_btn.addEventListener("click", () => {
          this.open = true
        })
      }
    }
  })

  // 折叠内容
  customElements.define("collapsible-content", class CollapsibleContent extends HTMLElement {
    constructor() {
      super();
      // Define observed attributes
      this.isExpanded = this.hasAttribute('expanded');
      this.initialHeight = this.getAttribute('initial-height') || '100px';
      this.contentWrapper = null;
      this.toggleButton = null;
      this.init();
    }

    static get observedAttributes() {
      return ['expanded', 'initial-height'];
    }

    init() {
      // Wrap the content
      this.contentWrapper = document.createElement('div');
      this.contentWrapper.className = 'collapsible-content__wrapper';
      // Move all children into wrapper
      while (this.firstChild) {
        this.contentWrapper.appendChild(this.firstChild);
      }
      this.appendChild(this.contentWrapper);

      // Create toggle button
      this.toggleButton = document.createElement('button');
      this.toggleButton.className = 'collapsible-content__toggle';
      this.toggleButton.textContent = this.isExpanded ? 'Show Less' : 'Show More';
      this.appendChild(this.toggleButton);

      // Set initial state
      this.updateState();

      // Add click listener
      this.toggleButton.addEventListener('click', () => {
        this.isExpanded = !this.isExpanded;
        this.updateState();
      });
    }

    updateState() {
      if (this.isExpanded) {
        this.contentWrapper.style.maxHeight = this.contentWrapper.scrollHeight + 'px';
        this.toggleButton.textContent = '- Show Less';
      } else {
        this.contentWrapper.style.maxHeight = this.initialHeight;
        this.toggleButton.textContent = '+ Read More';
      }
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'expanded') {
        this.isExpanded = this.hasAttribute('expanded');
        this.updateState();
      } else if (name === 'initial-height') {
        this.initialHeight = newValue || '100px';
        if (!this.isExpanded) {
          this.updateState();
        }
      }
    }

    connectedCallback() {
      // Add necessary styles
      const style = document.createElement('style');
      style.textContent = `
        collapsible-content {
          display: block;
        }
        .collapsible-content__wrapper {
          overflow: hidden;
          transition: max-height 0.3s ease-out;
        }
        .collapsible-content__toggle {
          display: block;
          margin: 10px 0;
          padding: 8px 16px;
          border: none;
          background: transparent;
          color: var(--swiper-theme-color, #007bff);
          cursor: pointer;
          font-size: 14px;
        }
        .collapsible-content__toggle:hover {
          color: var(--swiper-theme-color, #007bff);
          background: transparent;
        }
      `;
      this.appendChild(style);
    }
  })

})();
